import cx from "classnames";
import { useRef } from "react";

import t, { AsHtml } from "utils/translate";
import {
  Popup,
  PopupRef
} from "@ww-digital/web-palette-react/dist/components/Popup/Popup/Popup";

import styles from "./styles.module.scss";

interface PriceSelectionCardProps {
  item: {
    eyebrow?: string;
    header: string;
    body: string;
    price: string;
    subprice?: string;
    image: string;
    terms?: string;
    onClick: () => void;
  };
  active: boolean;
}

export const PriceSelectionCard: React.FC<PriceSelectionCardProps> = ({
  item,
  active
}) => {
  const popupComponent = useRef<PopupRef>(null);

  const togglePopup = () => {
    popupComponent?.current?.togglePopup();
  };

  return (
    <div
      className={cx(styles.card, { [styles.active]: active })}
      onClick={item.onClick}
    >
      <div className={styles.inner}>
        {item.eyebrow && <div className={styles.eyebrow}>{item.eyebrow}</div>}
        <div className={styles.content}>
          <div className={styles.header}>{item.header}</div>
          <div className={styles.body}>{item.body}</div>
        </div>
        <div className={styles.priceWrapper}>
          <div className={styles.priceTerms}>
            <div className={styles.price}>{item.price}</div>
            {item.terms && (
              <Popup
                ref={popupComponent}
                config={{
                  position: "auto",
                  offset: 10,
                  hideClose: false
                }}
                clickOutsideDeactivates={true}
                handle={
                  <div
                    role="button"
                    onClick={togglePopup}
                    className={styles.info}
                    aria-label={t("OFFER_TERMS_TITLE")}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="20"
                      fill="none"
                    >
                      <path
                        fill="#3c34e5"
                        fill-rule="evenodd"
                        d="M3.541 10.001a6.96 6.96 0 1 1 13.919 0 6.96 6.96 0 0 1-13.919 0Zm6.96-8.46a8.46 8.46 0 1 0 0 16.92 8.46 8.46 0 0 0 0-16.92Zm-.717 4.83a.833.833 0 1 0 .002-.003v.001l-.002.002Zm-.822 3.021c0-.345.28-.625.625-.625h.913c.346 0 .625.28.625.625v2.824h.288a.625.625 0 1 1 0 1.25H10.5a.625.625 0 0 1-.625-.625v-2.824h-.288a.625.625 0 0 1-.625-.625Z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                }
              >
                <AsHtml
                  className={styles.terms}
                  value={item.terms}
                  tagType="p"
                />
              </Popup>
            )}
          </div>
          {item.subprice && (
            <div className={styles.subprice}>{item.subprice}</div>
          )}
        </div>
      </div>
      <div className={styles.image}>
        <img src={item.image} alt="" />
      </div>
    </div>
  );
};
